export default __webpack_public_path__ + "static/media/teamsnap_for_business_logo_white.60d13d09.png";